<script setup lang="ts">
import merge from 'lodash-es/merge';
import type { ListItemModel } from '../../../pages/cms/modules/opinion-sliders/_runtime/services/OpinionSlidersService';
import OpinionSlidersService from '../../../pages/cms/modules/opinion-sliders/_runtime/services/OpinionSlidersService';

defineOptions({
    name: 'WidgetOpinionSliderSettings'
});

interface FormSettings
{
    settings: any;
}

const emit = defineEmits<{
    (e: 'update:modelValue', payload: any): void;
}>();

const props = defineProps<{
    modelValue: any;
}>();

const module = ref('articles');
const defaults = ref<any>({
    page: null,
    opinionSlider: ''
});

const form = computed<FormType<FormSettings>>(() =>
{
    return props.modelValue;
});

function triggerModel(): void
{
    emit('update:modelValue', form.value);
}

async function fetchSlider(id: number): Promise<ListItemModel>
{
    if (id != 0)
    {
        const response = await OpinionSlidersService.fetchAutocompleteModel(id);

        return response || null;
    }

    return null;
}

async function searchSliders(query: string, limit: number): Promise<ListItemModel[]>
{
    return await OpinionSlidersService.getAutocompleteList(query, limit);
}

watch(() => form.value.settings, () =>
{
    triggerModel();
}, { deep: true });

onBeforeMount(async (): Promise<void> =>
{
    form.value.settings = merge(defaults.value, form.value.settings);
});
</script>

<template>
    <hr>
    <IdeoFormGroup :label="$t('[[[Wybierz stronę]]]')" :invalid-feedback="form.$errors.first('settings.page')" :state="form.$errors.state('settings.page')" required>
        <EditoPageSelector
            v-model="form.settings.page"
            :module="module"
            label=""
            :website="false"
            :preview="false"
            class="mb-0"
        />
    </IdeoFormGroup>
    <IdeoFormGroup :label="$t('[[[Rotator]]]')" :invalid-feedback="form.$errors.first('settings.opinionSlider')" :state="form.$errors.state('settings.opinionSlider')" required>
        <IdeoAutocomplete
            v-model="form.settings.opinionSlider"
            name="settings.opinionSlider"
            track-by="id"
            :placeholder="$t('[[[zacznij pisać aby wyszukać rotator...]]]')"
            :fetch="(id: number) => fetchSlider(id)"
            :search="(query: string, limit: number) => searchSliders(query, limit)"
            :disabled="form.language === null"
        >
            <template #selected="{ option }">
                <div class="text-wrap">
                    {{ option.name }}
                </div>
            </template>
            <template #option="{ option }">
                <div class="text-wrap">
                    {{ option.name }}
                </div>
            </template>
        </IdeoAutocomplete>
    </IdeoFormGroup>
</template>
